{
    "Accessibility menu": "Accessibility menu",
    "Reset settings": "Astellungen zrécksetzen",
    "Close": "Zoumaachen",
    "Content adjustments": "Inhalt Unpassungen",
    "Navigation adjustments": "Navigatioun Unpassungen",
    "Align Left": "Lénks ausriichten",
    "Adjust Font Size": "Schrëftgréisst unpassen",
    "Highlight Title": "Titel markéieren",
    "Highlight Links": "Links markéieren",
    "Readable Font": "Liesbar Schrëft",
    "Colour adjustments": "Faarfleg Unpassungen",
    "Dark Contrast": "Däischteren Kontrast",
    "Light Contrast": "Hellen Kontrast",
    "High Contrast": "Héijen Kontrast",
    "High Saturation": "Héij Sättigung",
    "Low Saturation": "Niddrég Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Tools",
    "Reading Guide": "Guide fir ze liesen",
    "Stop Animations": "Animatiounen stoppen",
    "Big Cursor": "Groussen Cursor",
    "Increase Font Size": "Schrëftgréisst erhéijen",
    "Decrease Font Size": "Schrëftgréisst ernidderegen",
    "Letter Spacing": "Zeechenofstand",
    "Line Height": "Linn Héicht",
    "Font Weight": "Schrëftgewiicht",
    "Dyslexia Font": "Schrëft fir Dyslexie",
    "Language": "Sprooch",
    "Accessibility widget": "Accessibility menu opmaachen",
    "Accessibility Profiles": "Accessibility Profiler",
    "Cognitive Disability": "Kognitiv Behënnerung",
    "Seizure Safe": "Sécher fir Epilepsie",
    "Accessibility statement": "Accessibility Erklärung"
  }